export const TEST_ID = 'assetsGridRowWrapper';
